import { cn } from '@renderer/lib/utils'
import { motion } from 'motion/react'
import { FC } from 'react'

const RATPCard:FC<{
    title: string
    description: string
    image: string
    onClick?: () => void
    rounded?: boolean
    shadowColor?: string
    bgColor?: string
    textColor?: string
    className?: string
}> = ({title, description, image, onClick, rounded, shadowColor, bgColor, textColor, className, ...props}) => {
  return (
    <motion.div
    layout
    {...props}
    className={cn("relative z-10 max-h-90", className)}
    whileTap={'whileTap'}
    whileHover={'whileTap'}
    onClick={onClick}
    initial={{
      opacity: 0
    }}
    animate={{
      opacity: 1
    }}
  >
    <motion.div
      id="shadow"
      variants={{
        whileTap: {
          scale: 1.05,
          rotate: 1,
          top: 30,
          left: 30,
          transition: {
            duration: 0.1,
            ease: 'easeInOut',
            type: 'spring'
          }
        }
      }}
      className={`${shadowColor} ${rounded ? 'rounded-4xl' : ''} pointer-events-auto absolute top-4 left-4 w-full h-full z-0`}
    />
    <motion.div
      id="content"
      variants={{
        whileTap: {
          scale: 1.05,
          rotate: -1
        }
      }}
      className={`flex flex-col gap-8 border-6 border-primary w-full h-full p-6 z-50 relative ${bgColor} ${textColor}  ${rounded ? 'rounded-4xl' : ''}`}
    >
      <motion.div id="imgBox" className="w-full h-50 overflow-hidden">
        <motion.img
          initial={{
            scale: 1
          }}
          variants={{
            whileTap: {
              scale: 1.1,
              transition: {
                visualDuration: 0.2,
                type: 'spring'
              }
            }
          }}
          src={`${import.meta.env.BASE_URL}assets/images/${image}`}
          alt={title}
          className="w-full h-full object-cover"
        />
      </motion.div>

      <h1 className={`text-2xl font-extrabold whitespace-pre-line ${textColor}`}>
        {title}
      </h1>
    </motion.div>
  </motion.div>
  )
}

export default RATPCard